// extracted by mini-css-extract-plugin
export default {"divider":"divider-x40lI"};